import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalServiceService } from './local-service.service';

@Injectable({
  providedIn: 'root',
})
export class ValidateServiceService {
  authkey = '';
  token: any;
  constructor(private http: HttpClient, public router: Router, private user: LocalServiceService) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const role = route.data['allowedRoles'];
    if (this.user.ifAuthenticated(role)) {
      // logged in so return true
      return true;
    }
    this.router.navigate(['/admin/login']);
    return false;
  }
  public formheader() {
    let userData = this.user.getUser();
    if (userData != undefined && userData.token) {
      this.token = userData.token;

    }
    let header = new HttpHeaders({ 'Content-Type': 'application/json' });
    header = header.append('Authorization', 'Bearer ' + this.token);
    return { headers: header };
  }

  public formheaderP() {
    let userData = this.user.getUser();
    if (userData != undefined && userData.token) {
      this.token = userData.token;

    }
    let header = new HttpHeaders();
    // let header = new HttpHeaders({ 'Content-Type': 'application/json' });
    header = header.append('Authorization', 'Bearer ' + this.token);
    return { headers: header };
  }

  public formheaderClientUrl() {
    let header = new HttpHeaders();
    // let header = new HttpHeaders({ 'Content-Type': 'application/json' });
    header = header.append('sk', 'Y2xpZW50VXJsUGF5bWVudA==');
    return { headers: header };
  }
}
